import { Component } from '@angular/core';
import { ObjectType } from '@vendasta/auxiliary-data-components';
import { ModifyCustomProductDataTaskDefinitionId } from '../../../component-loader/constants';
import {
  ChangeAuxiliaryDataComponentModule,
  ModifyAuxiliaryDataPanelComponent,
} from './modify-auxiliary-data-panel/modify-auxiliary-data-panel.component';
import {
  ModifyAuxiliaryGenericDataPanelComponent,
  ModifyAuxiliaryGenericDataPanelTemplate,
} from './modify-auxiliary-generic-data-panel.component';

@Component({
  template: ModifyAuxiliaryGenericDataPanelTemplate,
  imports: [ChangeAuxiliaryDataComponentModule, ModifyAuxiliaryDataPanelComponent],
})
export class ModifyAuxiliaryProductDataPanelComponent extends ModifyAuxiliaryGenericDataPanelComponent {
  objectType: ObjectType = 'product';
  panelTitle = 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.PRODUCT_DATA.ACTION_TITLE';
  panelSubtitle = 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.PRODUCT_DATA.ACTION_SUBTITLE';
  get taskDefinitionId(): string {
    return ModifyCustomProductDataTaskDefinitionId;
  }
  set taskDefinitionId(taskDefinitionId: string) {
    // This does nothing, just here to fulfill the interface.
  }
}
